import { css } from 'styled-components';
import isFunction from 'lodash/isFunction';

import { cssDeclaration } from '../_ThemeTwo_/Utils/Styles/cssDeclaration';

import { commonInputStyles } from './InputCommon';

// tslint:disable:max-line-length
// const getRightIcon: (color: string) => string = color => `"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='12'%3E%3Cpath fill='${encodeURIComponent(color)}' d='M9.53 5.1523l-8-4.9997A.998.998 0 0 0 .515.1256C.197.3026 0 .6366 0 1.0006V11c0 .364.197.698.515.875.152.083.318.125.485.125.184 0 .368-.051.53-.152l8-4.9998c.292-.183.47-.503.47-.848 0-.3449-.178-.6649-.47-.8479z'/%3E%3C/svg%3E%0A"`;
// const getLeftIcon: (color: string) => string = color => `"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='12'%3E%3Cpath fill='${encodeURIComponent(color)}' %20transform%3D%27translate%2810%2C%200%29%20scale%28-1%2C%201%29%27 d='M9.53 5.1523l-8-4.9997A.998.998 0 0 0 .515.1256C.197.3026 0 .6366 0 1.0006V11c0 .364.197.698.515.875.152.083.318.125.485.125.184 0 .368-.051.53-.152l8-4.9998c.292-.183.47-.503.47-.848 0-.3449-.178-.6649-.47-.8479z'/%3E%3C/svg%3E%0A"`;
// tslint:enable:max-line-length
export default css`
  .DayPicker {
    width: 25rem;
    font-size: 1rem;
  }

  .DayPicker-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    flex-direction: row;
    user-select: none;
  }

  .DayPicker-Months {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }

  .DayPicker-Month {
    display: table;
    table-layout: fixed;
    width: 100%;
    margin-top: 1em;
    border-collapse: separate;
    border-spacing: 0px 1px;
    user-select: none;
  }

  .DayPicker-NavButton {
    position: absolute;
    display: inline-block;
    width: 2em;
    height: 2em;
    cursor: pointer;
    background-position: center;
    background-size: ${({ theme: { datepicker: { navButton: { backgroundSize } } } }) => backgroundSize};
    background-repeat: no-repeat;
  }

  .DayPicker-NavButton--next {
    top: 1em;
    right: 0;
    left: auto;
    ${({ theme }) => {
    const colorValue = theme.datepicker.navButton.color;
    const nextIcon = theme.datepicker.navButton.nextIcon;

    const color = isFunction(colorValue) ? colorValue({ theme }) : colorValue;

    return `background-image: url(${nextIcon(color)});`;
  }}
  }

  .DayPicker-NavButton--prev {
    top: 1em;
    left: 0;
    right: auto;
    ${({ theme }) => {
    const colorValue = theme.datepicker.navButton.color;
    const prevIcon = theme.datepicker.navButton.prevIcon;

    const color = isFunction(colorValue) ? colorValue({ theme }) : colorValue;

    return `background-image: url(${prevIcon(color)});`;
  }}
  }

  .DayPicker-NavButton--interactionDisabled {
    display: none;
  }

  .DayPicker-Caption {
    display: table-caption;
  }

  .DayPicker-Caption > div {
    text-align: center;
    ${({theme: { themeTwo, datepicker: { month } }}) => css`
      ${month && month.fontSize ? cssDeclaration(themeTwo, 'font-size', month.fontSize) : 'font-size: 2rem'};
    `}
  }

  .DayPicker-Weekdays {
    display: table-header-group;
  }

  .DayPicker-WeekdaysRow {
    display: table-row;
    padding: 0;
  }

  .DayPicker-Weekday {
    ${({theme: { themeTwo, datepicker }}) => css`
      ${datepicker.weekday.fontSize ? cssDeclaration(themeTwo, 'font-size', datepicker.weekday.fontSize) : 'font-size: 1rem'};
      ${datepicker.weekday.border && cssDeclaration(themeTwo, 'border', datepicker.weekday.border)};
      font-weight: ${datepicker.weekday.fontWeight};
    `}
    display: table-cell;
    padding: 0.5em;
    color: ${({ theme: { datepicker: { weekday: { color } } } }) => color};
    text-align: center;
  }

  .DayPicker-Weekday abbr[title] {
    // These two lines remove the default browser underline on (abbr)eviations
    text-decoration: none;
    border: none;
  }

  .DayPicker-Body {
    display: table-row-group;
  }

  .DayPicker-Week {
    display: table-row;
  }

  .DayPicker-Day {
    display: table-cell;
    vertical-align: middle;
    text-align: center;
    cursor: pointer;

    ${
      ({theme, theme: { datepicker: { day } }}) => css`
          ${day.padding ? cssDeclaration(theme.themeTwo, 'padding', day.padding) : 'padding: 0.5em'};
          ${day.border && cssDeclaration(theme.themeTwo, 'border', day.border)};
          ${day.fontSize ? cssDeclaration(theme.themeTwo, 'font-size', day.fontSize) : 'font-size: 1.6rem'};
      `
    }
  }

  .DayPicker--interactionDisabled .DayPicker-Day {
    cursor: default;
  }

  .DayPicker-Footer {
    display: flex;
    justify-content: center;
  }

  .DayPicker-TodayButton {
    border: none;
    background-color: transparent;
    background-image: none;
    box-shadow: none;
    color: ${({ theme: { link } }) => link.colorLink};
    font-size: 1.6rem;
    cursor: pointer;
  }

  .DayPicker-Day--outside {
    color: ${({ theme }) => theme.colorSlate};
    cursor: default;
  }

  .DayPicker-Day--disabled {
    color: ${({ theme: { datepicker: { day: { disabled: { color } } } } }) => color};
    cursor: default;
  }

  .DayPicker-NavButton:focus,
  .DayPicker-Day:focus,
  .DayPicker-wrapper:focus {
    outline: ${({ theme: { datepicker: { outline } } }) => outline};
  }

  .DayPicker-Day--selected {
    border-radius: ${({ theme: { datepicker: { selection } } }) => selection.borderRadius};
    position: relative;
    background-color: ${({ theme: { datepicker: { selection } } }) => selection.backgroundColor};
    color: ${({ theme: { datepicker: { selection } } }) => selection.color}
  }

  .DayPicker:not(.DayPicker--interactionDisabled) {
    .DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):hover {
      background-color: ${({ theme: { datepicker: { day: { hover: { backgroundColor } } } } }) => backgroundColor};
      color: ${({ theme: { datepicker: { day: { hover: { color } } } } }) => color};
      font-weight: 700;
    }
  }

  /* DayPickerInput */
  .DayPickerInput {
    input {
      ${commonInputStyles}

      padding-right: 2.75em;
      ${
        ({ theme: { datepicker: { input } } }) => `
          background-image: url("${input.icon}");
        `
      }
      background-position: right 0.75em center;
      background-repeat: no-repeat;
      background-size: auto 50%;
    }
  }

  .DayPickerInput-OverlayWrapper {
    position: relative;
  }

  .DayPickerInput-Overlay {
    display: flex;
    justify-content: center;
    position: absolute;
    left: 0;
    z-index: 1;
    margin-bottom: 1em;

    background: ${({ theme: { card } }) => card.colorBackground};
    box-shadow: ${({ theme: { card } }) => card.boxShadow};
    border: ${({ theme: { card } }) => card.borderWidth} solid ${({ theme: { card } }) => card.colorBorder};
    border-top: none;
    padding: 1em;
    border-radius: ${({ theme: { input, datepicker } }) => (datepicker.overlay && datepicker.overlay.borderRadius) || input.borderRadius};

  }
`;
